import React from 'react';

export const SubmissionsModalDeleteIcon = ({ ...rest }) => {
  return (
    <svg
      width="103"
      height="116"
      viewBox="0 0 103 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <ellipse cx="50" cy="109" rx="50" ry="7" fill="#F4F4F4" />
      <g filter="url(#filter0_i_12_1144)">
        <path
          d="M28.5054 44.4365C28.239 42.6253 29.6428 41 31.4734 41H85.5266C87.3572 41 88.761 42.6253 88.4946 44.4365L79.377 106.436C79.1605 107.909 77.8972 109 76.4089 109H40.5911C39.1028 109 37.8395 107.909 37.623 106.436L28.5054 44.4365Z"
          fill="white"
        />
      </g>
      <path
        d="M29 44.3637C28.7781 42.8544 29.9479 41.5 31.4734 41.5H85.5266C87.0521 41.5 88.2219 42.8544 88 44.3637L78.8823 106.364C78.7019 107.591 77.6491 108.5 76.4089 108.5H40.5911C39.3509 108.5 38.2981 107.591 38.1177 106.364L29 44.3637Z"
        stroke="#315E97"
      />
      <path d="M76 47L85.5 60V61L82.5 81.5L76 47Z" fill="#B1D0FC" />
      <path
        d="M82.0154 68.9745C85.7653 68.6129 89.3621 70.9519 90.4549 74.7014L92.1338 80.4618C93.2266 84.2114 91.4496 88.1165 88.0926 89.8262L82.0154 68.9745Z"
        stroke="#315E97"
        strokewidth="3"
      />
      <rect
        x="77.2603"
        y="47.2988"
        width="67"
        height="9"
        rx="1.5"
        transform="rotate(73.7512 77.2603 47.2988)"
        fill="white"
        stroke="#315E97"
      />
      <path
        fillrule="evenodd"
        cliprule="evenodd"
        d="M38.0625 75H33.375L29.7812 79.7114L30.5 88.5L36 99L29.5 89L27.9844 82.0671C26.7901 83.6328 25.7733 85.3261 24.9525 87.1159L21.1106 95.4941C17.7862 102.743 23.0833 111 31.0586 111H48.8591C53.7602 111 57.1479 106.098 55.4156 101.514C52.4135 93.5685 47.9924 86.2351 42.3677 79.8711L38.0625 75Z"
        fill="#315E97"
      />
      <path
        d="M23.218 65.7369C30.0124 65.2428 35.7131 70.808 35.3825 77.6123C28.9374 77.2368 23.7484 72.1711 23.218 65.7369Z"
        fill="#315E97"
      />
      <path
        d="M44.2573 63.8009C45.8957 70.4133 41.3769 76.9746 34.615 77.8018C33.8929 71.3863 38.0061 65.414 44.2573 63.8009Z"
        fill="#315E97"
      />
      <path
        d="M31.5825 30.7295C28.0968 31.1847 25.2148 29.0964 24.5616 25.6424C26.4097 25.1591 28.103 25.5043 29.3568 26.4128C30.6106 27.3213 31.4661 28.8228 31.5825 30.7295Z"
        stroke="#315E97"
      />
      <path
        d="M33.4822 29.9976C32.4429 26.6395 34.0126 23.4452 37.306 22.2162C38.0955 23.9557 38.0422 25.683 37.3593 27.0726C36.6764 28.4623 35.3416 29.5598 33.4822 29.9976Z"
        stroke="#315E97"
      />
      <rect
        x="29.9459"
        y="28.4987"
        width="5"
        height="5"
        rx="2.5"
        transform="rotate(-8.38509 29.9459 28.4987)"
        fill="#315E97"
      />
      <path
        d="M73.1702 12.5319C70.3912 10.3791 69.8424 6.86263 71.8332 3.96543C73.4784 4.93637 74.4264 6.3812 74.6652 7.91103C74.9039 9.44085 74.4412 11.1059 73.1702 12.5319Z"
        stroke="#315E97"
      />
      <path
        d="M75.028 13.3643C76.6788 10.2607 80.0514 9.12394 83.2441 10.5951C82.5659 12.3809 81.3027 13.5601 79.8354 14.0546C78.3682 14.5492 76.6488 14.3753 75.028 13.3643Z"
        stroke="#315E97"
      />
      <rect
        x="73.6002"
        y="9.79877"
        width="5"
        height="5"
        rx="2.5"
        transform="rotate(36.8186 73.6002 9.79877)"
        fill="#315E97"
      />
      <path
        d="M64.048 31.8421C62.6499 31.5724 61.738 30.4752 61.7285 29.0514C62.5019 29.105 63.1191 29.437 63.5211 29.9207C63.9231 30.4044 64.1368 31.0719 64.048 31.8421Z"
        stroke="#315E97"
      />
      <path
        d="M65.5139 31.7542C65.5428 30.3306 66.4696 29.246 67.8712 28.9953C67.9494 29.7666 67.7268 30.4311 67.3182 30.9093C66.9096 31.3875 66.288 31.7111 65.5139 31.7542Z"
        stroke="#315E97"
      />
      <rect
        x="63.7405"
        y="30.8443"
        width="2.5"
        height="2.5"
        rx="1.25"
        transform="rotate(5.95631 63.7405 30.8443)"
        fill="#315E97"
      />
      <defs>
        <filter
          id="filter0_i_12_1144"
          x="28.4729"
          y="41"
          width="60.0542"
          height="68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="18" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.694118 0 0 0 0 0.815686 0 0 0 0 0.988235 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_12_1144" />
        </filter>
      </defs>
    </svg>
  );
};

export default SubmissionsModalDeleteIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/SubmissionsModalDeleteIcon.jsx